import { useState } from "react";
import particleImg from "../../../assets/images/particle-3.png";
import startuplogo from "../../../assets/images/footer-logo.png";
import applyNow from "../../../assets/images/apply-now.png";
import fbFooter from "../../../assets/images/fb-footer.png";
import twitFooter from "../../../assets/images/twit-footer.png";
import linkedInFootet from "../../../../src/assets/images/linkedin-footer.png";
import swal from "sweetalert";
import youTubeFooter from "../../../../src/assets/images/youtube-footer.png";
import "./styles.scss";
import pdfFile from "../../../assets/pdf/mentor tutorial.pdf";
import userGuide from "../../../assets/pdf/MAARGStartupUserGuide-April 23.pdf";
import { useTranslation } from "react-i18next";
import fbImg from "../../../../src/assets/images/fb.png";
import twitterImg from "../../../../src/assets/images/twit.png";

import linkedIn from "../../../../src/assets/images/linkedin.png";
import youTube from "../../../../src/assets/images/youtube.png";
const Footer = (props) => {
  const { getHeaderData, footerData } = props;
  const { t } = useTranslation();

  return (
    <footer>
      <div className="w-100 pt-40 bg-color26 position-relative">
        <div className="particles-wrap position-absolute w-100">
          <div
            id="particle-4"
            className="particles-js w-100"
            data-color="#3E4A59"
            data-size="80"
            data-count="5"
            data-speed="2"
            data-hide="767"
            data-shape="image"
            data-mode="bounce"
            data-image-url={particleImg}
            data-image-width="150"
            data-image-height="150"
          >
            <canvas></canvas>
          </div>
        </div>
        <div className="container">
          <div className="footer-data position-relative w-100">
            <div className="row">
              <div className="col-md-4 col-sm-6 col-lg-2 footermobile">
                <div className="widget w-100 foot-logo">
                  <a href="#!">
                    {" "}
                    <img src={startuplogo} className="footer-logo" />
                  </a>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-lg-3 footermobile">
                <div className="widget text-center w-100">
                  {/* <p>
                    Address :<br></br>
                    Invest India 110 Vigyan Bhavan Annex 001 Maulana Azad Road
                    New Delhi 110 001
                  </p> */}
                  <p>
                    {t("EMAIL")}:
                    <a href="mailto:startup.support@investindia.org.in">
                      {" "}
                      startup.support@investindia.org.in
                      {/* mentorship@startupindia.gov.in */}
                    </a>{" "}
                  </p>
                  <ul
                    style={{ textAlign: "left" }}
                    className="footer-contact-list list-unstyled pt-5 mb-0 w-100"
                  >
                    <li>
                      <a
                        href="https://www.startupindia.gov.in/content/sih/en/terms-of-use.html"
                        title=""
                        target="_blank"
                      >
                        {t("TERMS_OF_USE")}
                        {/* Terms of Use */}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.startupindia.gov.in/content/sih/en/privacy-policy.html"
                        title=""
                        target="_blank"
                      >
                        {t("PRIVACY_POLICY")}
                        {/* Privacy Policy */}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.startupindia.gov.in/content/sih/en/disclaimer.html"
                        title=""
                        target="_blank"
                      >
                        {t("DISCLAIMER")}
                        {/* Disclaimer{" "} */}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 col-lg-2 footermobile">
                <div className="widget text-center w-100">
                  <ul
                    className="footer-contact-list list-unstyled mb-0 w-100"
                    style={{ textAlign: "left" }}
                  >
                    <li>
                      <a
                        href="/about-us"
                        onClick={() =>
                          localStorage.setItem("activePage", "aboutus")
                        }
                        title=""
                      >
                        {t("About_US")}
                        {/* About */}
                      </a>
                    </li>
                    <li>
                      <a
                        href="/become-mentor"
                        onClick={() =>
                          localStorage.setItem("activePage", "becomeMentor")
                        }
                        title=""
                      >
                        {t("BECOME_A_MENTOR")}
                        {/* Become A Mentor */}
                      </a>
                    </li>
                    <li>
                      <a
                        href="/get-a-mentor"
                        onClick={() =>
                          localStorage.setItem("activePage", "findMentor")
                        }
                        title=""
                      >
                        {t("GET_A_MENTOR")}
                        {/* Get A Mentor */}
                      </a>
                    </li>
                    <li>
                      <a
                        href="/cohort-program"
                        onClick={() =>
                          localStorage.setItem("activePage", "cohortProgram")
                        }
                        title=""
                      >
                        {t("COHORT_PROGRAMS")}
                        {/* Cohort Programs */}
                      </a>
                    </li>
                    {/* <li>
                      <a href="#!" title="">
                        Resources{" "}
                      </a>
                    </li> */}
                    <li>
                      <a
                        href="/faq"
                        onClick={() =>
                          localStorage.setItem("activePage", "FAQ")
                        }
                        title=""
                      >
                        {t("FAQs")}
                        {/* FAQs{" "} */}
                      </a>
                    </li>
                    <li>
                      <a
                        href="/contactus"
                        onClick={() =>
                          localStorage.setItem("activePage", "contactus")
                        }
                        title=""
                      >
                        {t("CONTACT")}
                        {/* Contact{" "} */}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 col-lg-2 ">
                <div className="widget text-center w-100">
                  {/* <ul className="footer-contact-list list-unstyled mb-0 w-100">
                    <li>
                      <a href="#!" title="">
                        Terms of Use
                      </a>
                    </li>
                    <li>
                      <a href="#!" title="">
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="#!" title="">
                        Disclaimer{" "}
                      </a>
                    </li>
                  </ul> */}
                </div>
              </div>
              <div
                className="col-md-4 col-sm-6 col-lg-1 footermobilebtns"
                style={{ maxHeight: "275px" }}
              >
                <div className="widget w-100 header-cart-box2">
                  <a>
                    {" "}
                    {/* <img src={applyNow} /> */}
                    <button className="footerApplyBtn">
                      {" "}
                      {t("APPLY_NOW")}
                      {/* APPLY NOW */}
                    </button>
                  </a>
                  <div class="minicart-dropdown">
                    <a href="/login" className="interested-link footer-btn">
                      {t("APPLY_AS_A_MENTOR")}
                      {/* APPLY AS A MENTOR  */}
                    </a>
                    <p class="footer-p">
                      {t(
                        "Register_as_an_individual_mentor_to_start_contributing"
                      )}
                      {/* Register as an individual mentor to start contributing{" "} */}
                    </p>

                    <a href="/login" className="interested-link footer-btn"
                      style={{ cursor: "pointer" }}
                    // onClick={() =>
                    //   swal(
                    //     "Please stay tuned, this function will be enabled shortly after the launch of Startup onboarding process.",
                    //     { closeOnClickOutside: false }
                    //   )
                    // }
                    // className="interested-link footer-btn"
                    >
                      {t("APPLY_AS_A_STARTUP")}
                      {/* APPLY AS A STARTUP */}
                    </a>
                    <p class="footer-p">
                      {t(
                        "Register_as_a_startup_to_get_a_mentor_and_start_mentorship"
                      )}
                      {/* Register as a startup to get a mentor and start mentorship{" "} */}
                    </p>

                    <a
                      href="/login" className="interested-link footer-btn"
                      // href="/cohort-form"
                      style={{ cursor: "pointer" }}
                    // onClick={() =>
                    //   swal(
                    //     "Please stay tuned, this function will be enabled shortly after the launch of Cohort onboarding process.",
                    //     { closeOnClickOutside: false }
                    //   )
                    // }
                    // className="interested-link footer-btn"
                    >
                      {t("APPLY_AS_A_COHORT")}
                      {/* APPLY AS A COHORT */}
                    </a>
                    <p class="footer-p">
                      {t(
                        "Register_a_new_cohort_as_individual_mentor_or_association"
                      )}
                      {/* Register a new cohort as individual mentor or association{" "} */}
                    </p>

                    {/* <div class="more-details">
                      <a href="#">
                        For more details, get in touch with us at
                        startup.support@investindia.org.in
                      </a>
                    </div> */}
                  </div>
                </div>
                <div className="widget w-100 header-cart-box3 newuserTooltip ">
                  <a target="_blank" href={pdfFile}>
                    <button className="footerApplyBtn">
                      {t("REGISTRATION_TUTORIAL_FOR MENTORS")}
                      {/* REGISTRATION TUTORIAL FOR MENTORS{" "} */}
                    </button>
                  </a>
                  <span
                    className="tooltiptext tooltip-bottom guidebook"

                  >
                    Click to Open Guide Book for Mentors
                  </span>
                </div>
                <div/>
                {/* <div className="widget w-100 header-cart-box5 newuserTooltip ">
                  <a target="_blank" href={userGuide}>
                    <button className="footerApplyBtn">
                      {t("USER_GUIDE_FOR_STARTUPS")}
                    </button>
                  </a>
                  <span
                    className="tooltiptext tooltip-bottom guidebook"

                  >
                    Click to Open Guide Book for Startups
                  </span>
                </div> */}
                                      {/* REGISTRATION TUTORIAL FOR MENTORS{" "} */}

              </div>
              <div className="col-md-4 col-sm-6 col-lg-2 text-center footersocial">
                <div className="social-links d-inline-flex flex-wrap  ">
                  <div className="newuserTooltip" style={{ padding: "0 2px" }}>
                    <a
                      href="https://www.linkedin.com/company/startup-india/"
                      // title="Linkedin"
                      target="_blank"
                    >
                      <img src={linkedIn} />
                    </a>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "32px", top: "33px", width: "90px" }}
                    >
                      LinkedIn
                    </span>
                  </div>
                  <div className="newuserTooltip" style={{ padding: "0 2px" }}>
                    <a
                      href="https://twitter.com/startupindia?lang=en"
                      // title="Twitter"
                      target="_blank"
                    >
                      <img src={twitterImg} />
                    </a>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "32px", top: "33px", width: "90px" }}
                    >
                      Twitter
                    </span>
                  </div>

                  <div className="newuserTooltip" style={{ padding: "0 2px" }}>
                    <a
                      href="https://www.facebook.com/StartupIndia/"
                      // title="Facebook"
                      target="_blank"
                    >
                      <img src={fbImg} />
                    </a>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "32px", top: "33px", width: "90px" }}
                    >
                      Facebook
                    </span>
                  </div>

                  <div className="newuserTooltip" style={{ padding: "0 2px" }}>
                    <a
                      href="https://www.youtube.com/channel/UCqFb-ynHTJ6_YRbdn-sFUvg/featured"
                      // title="Youtube"
                      target="_blank"
                    >
                      <img src={youTube} />
                    </a>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "32px", top: "33px", width: "90px" }}
                    >
                      Youtube
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
